<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                ...this.data,
            }
        },
        render(h) {
            return h('div', this.$scopedSlots.default(this));
        },
    }
</script>
